import withReducer from '../../store/withReducer'
import Reports from './container'
import reducer from './module'

export default withReducer('reports', reducer)(Reports)



// WEBPACK FOOTER //
// ./src/legacy/pages/Reports/index.js